var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0534 18.7349L13.9714 21.8168C13.121 22.6672 11.7392 22.6664 10.8889 21.8161L2.27211 13.1993C1.42186 12.3491 1.42105 10.9673 2.27144 10.1169L5.35338 7.03492C6.20377 6.18453 7.58561 6.18534 8.43586 7.03559L17.0527 15.6524C17.9029 16.5026 17.9037 17.8845 17.0534 18.7349Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8512 21.8151L7.76924 18.7331C6.91885 17.8827 6.91941 16.5011 7.77008 15.6505L21.6476 1.77297C22.4983 0.922295 23.8798 0.921786 24.7302 1.77217L27.8121 4.85412C28.6625 5.7045 28.662 7.08604 27.8113 7.93672L13.9338 21.8142C13.0832 22.6649 11.7016 22.6655 10.8512 21.8151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico-check.e1f6ae36e096a6aa53952d5cd63e04e4.svg";
export { ForwardRef as ReactComponent };